import React from 'react';
import PropTypes from 'prop-types';

import './InlineErrorBoundary.module.scss';

class InlineErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    errorText: PropTypes.string,
  };

  static defaultProps = {
    errorText: 'Sorry, something went wrong!',
  };

  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }

  render() {
    const { error, errorInfo } = this.state;
    const { children, errorText } = this.props;

    if (error || errorInfo) {
      return <p>{errorText}</p>;
    }

    return children;
  }
}

export default InlineErrorBoundary;
